import React from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import ChangePassword from "./component/changePassword";

// css
import styles from "./setting.module.scss";
import PersonalInformation from "./component/PersonalInformation";

const Setting = () => {
  return (
    <>
      <section className={`${styles.setting} Setting position-relative py-2`}>
        <Container>
          <Row className="justify-content-center">
            <Col lg="6" md="10" className="py-2">
              <div className="box cardCstm p-3 px-lg-4 position-relative">
                <Tab.Container id="left-tabs-example" defaultActiveKey="PersonalInformation">
                  <Nav
                    variant="pills"
                    className="underlineTab border-bottom mx-auto justify-content-center mb-3"
                    style={{ maxWidth: "max-content" }}
                  >
                    <Nav.Item>
                      <Nav.Link
                        eventKey="PersonalInformation"
                        className="bg-transparent position-relative fw-sbold"
                      >
                        Personal Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="ChangePassword"
                        className="bg-transparent position-relative fw-sbold"
                      >
                        Change Password
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="PersonalInformation">
                      <PersonalInformation />
                    </Tab.Pane>
                    <Tab.Pane eventKey="ChangePassword">
                      <ChangePassword />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Setting;
